/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Claim_Credit_Not_OpenInputs */

const en_error_claim_credit_not_open = /** @type {(inputs: Error_Claim_Credit_Not_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The credit note of this claim cannot be approved: Zendesk did not close it with a credit note, it names no line and units, or it is approved already.`)
};

/**
* | output |
* | --- |
* | "The credit note of this claim cannot be approved: Zendesk did not close it with a credit note, it names no line and units, or it is approved already." |
*
* @param {Error_Claim_Credit_Not_OpenInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_claim_credit_not_open = /** @type {((inputs?: Error_Claim_Credit_Not_OpenInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Claim_Credit_Not_OpenInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_claim_credit_not_open(inputs)
});